import { TrialState } from '../models/TrialState';

export const trialStatesIncludesExtendedTrial = (
  trialStates: Array<TrialState> | undefined
): boolean => {
  return (
    trialStates?.some((trialState) => trialState.status === 'extended') ?? false
  );
};
